import Icon from 'veui/components/Icon'

Icon.register({
  'paper-plane': {
    paths: [
      {
        d: 'M288 704a32 32 0 01-32-32V480a32 32 0 0110.29-23.51l160-147.7a32 32 0 0143.42 47L320 494v79l23.23-32.17a32 32 0 0139.57-10.21l200.58 94.39 78.72-472.28-524.8 262.4 75.78 35.66a32 32 0 11-27.25 57.91L50.37 445a32 32 0 01-.68-57.57l640-320a32 32 0 0145.87 33.88l-96 576A32 32 0 01594.37 701l-214.8-101.13-65.63 90.87A32 32 0 01288 704z'
      }
    ],
    width: '768',
    height: '768'
  }
})
